import { useGeneralHook } from "api/hooks/allHooks";
import { customApiCall } from "utils/axios";

import addBuildingUrls from "./urls";

const getBuildingOutline = async ({ lat, lng }: { lat: number; lng: number }) => {
  const url = addBuildingUrls.outline();
  const data = {
    latitude: lat,
    longitude: lng,
  };

  const resp = await customApiCall.post({ data, url });
  const polygon = resp.unified_polygon_latlon;
  return polygon;
};

export const useGetBuildingOutline = ({
  enabled = true,
  lat,
  lng,
}: {
  enabled?: boolean;
  lat: number;
  lng: number;
}) => {
  return useGeneralHook(["buildingOutline", lat, lng], () => getBuildingOutline({ lat, lng }), {
    enabled,
  });
};
